/**
 * Адреса тура: совпадение адресов без учёта порядка параметров и адрес шага в учебном
 * экземпляре тура.
 */

import type { TrainingManifest } from '@/api/training';
import { TRAINING_INSTANCE_PARAM, workspaceHref } from '@/features/workspace/workspaceRoutes';
import { LESSONS, stepRoute, type LessonId } from './catalog';

function normalized(href: string): string {
	const [pathname, query = ''] = href.split('?');
	const params = [...new URLSearchParams(query).entries()]
		.map(([key, value]) => `${key}=${value}`)
		.sort();
	return [pathname, ...params].join('&');
}

export function sameHref(a: string, b: string): boolean {
	return normalized(a) === normalized(b);
}

/** Путь адреса без запроса, раскодированный и без завершающей косой черты */
function pathOf(href: string): string {
	const pathname = href.split('?')[0];
	let decoded = pathname;
	try {
		decoded = decodeURIComponent(pathname);
	} catch {
		/* Неверная кодировка: сравнивается как есть */
	}
	return decoded.replace(/\/+$/, '') || '/';
}

/** Один и тот же путь: параметры запроса и кодирование сегментов не важны */
export function samePath(a: string, b: string): boolean {
	return pathOf(a) === pathOf(b);
}

/** Адрес шага урока в учебном экземпляре тура */
export function tourStepHref(lesson: LessonId, index: number, manifest: TrainingManifest): string {
	return workspaceHref(stepRoute(LESSONS[lesson].steps[index], manifest), {
		training_instance_id: manifest.instance_id,
	});
}

/** Адрес относится к учебному контуру */
export function isTrainingHref(href: string): boolean {
	return new URLSearchParams(href.split('?')[1] ?? '').has(TRAINING_INSTANCE_PARAM);
}
